'use strict';

module.exports = require('extract-files/public/isExtractableFile');
